import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AppShell from "@/pages/AppShell";
import MyServices from "@/pages/MyServices";
import Home from "@/pages/Home";
import Contacts from "@/pages/Contacts";
import Coupons from "@/pages/Coupons";
import Earnings from "@/pages/Earnings";
import SalesReport from "@/pages/SalesReport";
import VideosReport from "@/pages/VideosReport";
import ProtocolFocusPage from "@/pages/ProtocolFocusPage";
import ProtocolFlyer from "@/pages/ProtocolFlyer";
import PublicFormPage from "@/pages/PublicFormPage";
import Placeholder from "@/pages/Placeholder";
import Profile from "@/pages/Profile";
import Catalogue from "@/pages/Catalogue";
import Folio from "@/pages/Folio";
import Blog from "@/pages/Blog";
import EquityHub from "@/pages/EquityHub";
import DealerPage from "@/pages/DealerPage";
import DealerProductPage from "@/pages/DealerProductPage";
import Landing from "@/pages/Landing";
import PageView from "@/pages/PageView";
import TagPage from "@/pages/TagPage";
import TagsIndex from "@/pages/TagsIndex";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import TextAlerts from "@/pages/TextAlerts";
import SmsLegal from "@/pages/SmsLegal";
import SiteFooter from "@/components/SiteFooter";
import ChatWidget from "@/components/ChatWidget";
import RequireApproval from "@/components/RequireApproval";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex min-h-screen flex-col">
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/d/:slug" element={<DealerPage />} />
              <Route path="/protocols" element={<Navigate to="/d/orevital?view=protocols" replace />} />
              <Route path="/protocols/flyer" element={<ProtocolFlyer />} />
              <Route path="/form/:token" element={<PublicFormPage />} />
              <Route path="/protocols/:slug" element={<ProtocolFocusPage />} />
              <Route path="/d/:slug/product/:productSlug" element={<DealerProductPage />} />
              <Route path="/product/:productSlug" element={<DealerProductPage />} />
              <Route path="/home/:slug" element={<DealerPage />} />
              <Route path="/page/:slug" element={<PageView />} />
              <Route path="/tags" element={<TagsIndex />} />
              <Route path="/tags/:slug" element={<TagPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/d/:slug/events" element={<EventsPage />} />
              <Route path="/events/:slug" element={<EventDetailPage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Blog />} />
              <Route path="/post/:slug" element={<Blog />} />
              <Route path="/posts/:slug" element={<Blog />} />
              <Route path="/text-alerts" element={<TextAlerts />} />
              <Route path="/text-alerts/terms" element={<SmsLegal type="terms" />} />
              <Route path="/text-alerts/privacy" element={<SmsLegal type="privacy" />} />
              <Route path="/app" element={<AppShell />}>
                <Route index element={<Navigate to="earnings" replace />} />
                <Route path="home" element={<Home />} />
                <Route
                  path="contacts"
                  element={<RequireApproval><Contacts /></RequireApproval>}
                />
                <Route
                  path="coupons"
                  element={<RequireApproval><Coupons /></RequireApproval>}
                />
                <Route
                  path="earnings"
                  element={<Earnings />}
                />
                <Route path="profile" element={<Profile />} />
                <Route path="sales-report" element={<SalesReport />} />
                <Route path="videos-report" element={<VideosReport />} />
                <Route path="equity" element={<EquityHub />} />
                <Route path="catalogue" element={<Catalogue />} />
                <Route path="folio" element={<RequireApproval><Folio /></RequireApproval>} />
                <Route path="services" element={<RequireApproval><MyServices /></RequireApproval>} />
                <Route path="blog" element={<Blog />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <SiteFooter />
        </div>
        <ChatWidget />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
